// Core lib dependencies.
import React from 'react';
import PropTypes from 'prop-types';

/**
 * PrivacyPolicy React component.
 *
 * Create a privacy policy element that displays a localized privacy policy statement
 * with customizable privacy policy link.
 *
 * @memberof module:PrivacyManagement.Components
 * @namespace
 *
 * @return {PrivacyManagement.Components.PrivacySettingsButton}
 */
const PrivacyPolicy = (props) => {
  // If you update this parameter name, you must also update the labels & translations files and DB table ref_label.
  const POLICY_PARAMETER_NAME = 'policy-link';

  const policyLinkEl = (
    <a key={POLICY_PARAMETER_NAME} href={props.linkUrl} target="_blank" aria-label={props.linkTitle} tabIndex="0">
      {props.linkTitle}
    </a>
  );

  // Break into an array of strings with one of the elements being the parameter name
  const policyArray = props.parameterizedText.split(/[{}]/);

  // Find the array item that holds the parameter.  Customers can move this around, it could appear anywhere in the string.
  const replaceIdx = policyArray.indexOf(POLICY_PARAMETER_NAME);

  // If we found it, replace it with the link ELEMENT so we can produce parsable HTML for the browser.
  if (replaceIdx > -1) policyArray[replaceIdx] = policyLinkEl;

  return <span>{policyArray}</span>;
};

/**
 * React PropTypes.
 *
 * @type {Object}
 * @property {string} parameterizedText Text to display with the privacy policy link with a place holder where we should insert the link element
 * @property {string} linkUrl URL for the privacy policy link
 * @property {string} linkTitle Text for the privacy policy link
 */
PrivacyPolicy.propTypes = {
  parameterizedText: PropTypes.string,
  linkUrl:           PropTypes.string,
  linkTitle:         PropTypes.string,
};

export default PrivacyPolicy;
